// Leave Type and Leave Request Permissions
//
// ⚠️ RECONCILE BEFORE RELEASE. Same allocation caveat as attendance.js —
// 1548-1558 are counted forward from the confirmed 1522 — derived, not read.
// Confirm off the live rows:
//
//     SELECT id, name FROM permissions
//     WHERE name LIKE 'leave_types.%' OR name LIKE 'leaves.%';
export const LEAVE_TYPES_INDEX = 1548;
export const LEAVE_TYPES_CREATE = 1549;
export const LEAVE_TYPES_UPDATE = 1550;
export const LEAVE_TYPES_DELETE = 1551;
export const LEAVE_TYPES_RESTORE = 1552;

export const LEAVES_INDEX = 1553;
export const LEAVES_CREATE = 1554;
export const LEAVES_DELETE = 1555;
export const LEAVES_RESTORE = 1556;
// One key for both halves of the decision: whoever may grant leave may refuse
// it, and a reject-only permission would let someone block a request they
// cannot grant.
export const LEAVES_DECIDE = 1557;
// Its own key because cancelling is allowed AFTER approval — it withdraws leave
// already granted and hands the balance back.
export const LEAVES_CANCEL = 1558;
